"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parseJwt = function (token) {
    if (!token)
        return undefined;
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};
exports.default = parseJwt;
